import src from "IMAGE";
export default { src, width: 226, height: 428, blurWidth: 0, blurHeight: 0};
